<template>
    <div @click="handleClick()">
            <template>
                <span style="display: inline-block;color:red">{{ row.name }}</span>
            </template>
        </div>
</template>

<script>
export default {
 	props: {
 	    row: {
 	                type: Object,
 	                default: function () {
 	                    return {}
 	                }
 	            }
    },
    data: function() {
    },
    computed: {
    },
    watch: {
    },
    created: function() {
    },
    beforeDestroy: function() {
    },
    mounted: function() {
    },
    methods: {
        handleClick() {
        }

    }
}
</script>

<style>
</style>
